/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Alpha = (color = "#000000", alphaNumber = 0) => {
  if (
    typeof color === "string" &&
    color.length === 7 &&
    typeof alphaNumber === "number" &&
    (alphaNumber >= 0 || alphaNumber <= 1)
  ) {
    const hexArr = [color.substr(1, 2), color.substr(3, 2), color.substr(5, 2)];
    const alphaArr = [
      parseInt(hexArr[0], 16),
      parseInt(hexArr[1], 16),
      parseInt(hexArr[2], 16),
    ];

    return `rgba(${alphaArr.join(",")}, ${alphaNumber})`;
  }

  return "transparent";
};

const Colors = {
  PRIMARY1: "#006643",
  PRIMARY: "#FFFFFF",
  SECONDARY1: "#FDC830",
  SECONDARY: "#65A518",
  GRAY: [
    "#666666",
    "#888888",
    "#A3A3A3",
    "#C0C0C0",
    "#E0E0E0",
    "#F5F5F5",
    "#53565A",
    "#2C2A28",
    "#898887",
    "#AEAEADB8",
    "#F2F2F2",
    "#E8E8E8",
  ],
  
  DANGER: "#EB4C3D",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  RED: "#DB0F16",
  PINK: "#D6006E",
  GREEN: "#006643",
  PURPLE: "#24195D",
  YELLOW: "#F8A934",
  DARK_GREEN: "#0d593f",
  Alpha,
};

export default Colors;
